var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},[_c('div',{staticClass:"breadcrumbDiv"},[_c('breadcrumb',{attrs:{"bread":_vm.bread},on:{"handleBreadClick":_vm.handleBreadClick}})],1),_c('orderDetails',{key:_vm.partInfoKey,attrs:{"detailsData":_vm.detailsData,"loading":_vm.loading,"partner":2},on:{"getDetail":_vm.getDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }